/**
 * Central registry for blog categories. Independent from tool categories —
 * blog topics (guides, roundups) don't map 1:1 onto tool categories.
 *
 * To add a new category: add one entry below.
 */

export interface BlogCategoryDef {
  id: string;
  label: string;
  description: string;
  order: number;
}

export const blogCategories = [
  {
    id: 'guides',
    label: 'Guides',
    description: 'Step-by-step walkthroughs for using Kitorra tools.',
    order: 1,
  },
  {
    id: 'student-life',
    label: 'Student Life',
    description: 'Grades, study habits, and school-money advice.',
    order: 2,
  },
  {
    id: 'personal-finance',
    label: 'Personal Finance',
    description: 'Budgeting, saving, and everyday money decisions.',
    order: 3,
  },
  {
    id: 'productivity',
    label: 'Productivity',
    description: 'Focus, habits, and getting things done.',
    order: 4,
  },
] as const satisfies readonly BlogCategoryDef[];

export type BlogCategoryId = (typeof blogCategories)[number]['id'];

export const blogCategoryLabels = Object.fromEntries(
  blogCategories.map((c) => [c.id, c.label]),
) as Record<BlogCategoryId, string>;

export function getSortedBlogCategories(): (typeof blogCategories)[number][] {
  return [...blogCategories].sort((a, b) => a.order - b.order);
}
